/*
 *******************************************************************************
 *
 *  Filename:   /redux/slices/imrfs.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   IMRFS redux reducer
 *
 *  Author:     Norman J. Nolasco [ Archetact Software ]
 *
 *  Created:    Tuesday, May 7, 2024 - 9:56 AM (CST)
 *
 *  Notes:
 *
 *  Revisions:
 *              2024/05/07  NJN Initial Build
 *
 *  Copyright (c) 2024 - Archetact Software - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  imrfid: 0,
  companyid: 0,
  error: null,
  defaultToolPanel: "filter",
  order: "NAME ASC",
  search: "",
  columnState: [],
};

const intFields = ["companyid"];

const updateFieldReducer = (state, action, field) => {
  const value = action.payload ? action.payload[field] : undefined;

  if (value !== undefined) {
    state[field] = intFields.includes(field) ? parseInt(value, 10) : value;
    state.error = Number.isNaN(state[field]) ? `Invalid value for ${field}.` : null;
  } else {
    state.error = `No ${field} provided.`;
  }
};

export const imrfSlice = createSlice({
  name: "imrfs",
  initialState,
  reducers: {
    updateIMRFID: (state, action) => updateFieldReducer(state, action, "imrfid"),
    updateCompanyID: (state, action) => updateFieldReducer(state, action, "companyid"),
    updateDefaultToolPanel: (state, action) => updateFieldReducer(state, action, "defaultToolPanel"),
    updateColumnState: (state, action) => updateFieldReducer(state, action, "columnState"),
  },
});

export const { updateIMRFID, updateCompanyID, updateParentID, updateDefaultToolPanel, updateColumnState } =
  imrfSlice.actions;

export default imrfSlice.reducer;
